/* eslint-disable */
import Axios from 'axios';
import { clearDefaults } from './config';
import { auth0Client } from 'components/CustomHooks';
import { sendToLogger } from 'logger';
import { extLocalStore } from 'util/localStorage';

export const getAuth0Token = async () => {
	try {
		const [token, { __raw }] = await Promise.all([
			auth0Client.getTokenSilently(),
			auth0Client.getIdTokenClaims()
		]);
		return {
			accessToken: token,
			idToken: __raw
		};
	} catch (err) {
		return Promise.reject(err);
	}
};

const revokeRefreshTokenErrorMessage = 'Error revoking Auth0 refresh token';

export const revokeAuth0RefreshToken = async () => {
	const auth0 = extLocalStore.getAuth0Cache();
	const { refresh_token, client_id } = auth0.body;
	const { domain } = JSON.parse(localStorage.ext);

	const options = {
		method: 'POST',
		url: `https://${domain}/oauth/revoke`,
		headers: { 'content-type': 'application/json' },
		data: {
			client_id,
			token: refresh_token
		}
	};

	return Axios.request(options)
		.then((response) => {
			clearDefaults();
			return response.data;
		})
		.catch((err) => {
			sendToLogger({
				level: 'error',
				message: {
					message: revokeRefreshTokenErrorMessage,
					err
				}
			});
			return Promise.reject({ message: revokeRefreshTokenErrorMessage });
		});
};
